import { AutoFocus } from 'primeng/autofocus'

import { DeviceService } from '@ti/core/common/services'

export function patchAutoFocus() {
  /**
   * Patch the `AutoFocus::autoFocus` method to skip `[autofocus]` inside dialogs and sheets on phones
   *
   * Dialog content renders while the dialog animates in, so the on-screen keyboard would open mid-animation
   * The check waits a tick: a host may not be inside its dialog yet on the first change detection
   */
  const orig__AutoFocus_autoFocus = AutoFocus.prototype.autoFocus
  AutoFocus.prototype.autoFocus = function (...args) {
    if (!this.autofocus || !this.injector.get(DeviceService).isMobile()) {
      orig__AutoFocus_autoFocus.call(this, ...args)
      return
    }

    setTimeout(() => {
      if (this.focused) return

      if (this.host.nativeElement.closest('.p-dialog')) {
        this.focused = true
        return
      }
      orig__AutoFocus_autoFocus.call(this, ...args)
    })
  }
}
